import { useState, useEffect, useCallback } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

const SCROLL_SHOW_THRESHOLD = 400;
const SCROLL_START_THRESHOLD = 100;

export default function ScrollButtons() {
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(false);

  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY;
    const docHeight = document.documentElement.scrollHeight;
    const winHeight = window.innerHeight;

    setShowTop(scrollY > SCROLL_SHOW_THRESHOLD);
    setShowBottom(scrollY > SCROLL_START_THRESHOLD && scrollY < docHeight - winHeight - SCROLL_SHOW_THRESHOLD);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "auto" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "auto" });
  };

  return (
    <div className="fixed right-4 bottom-6 z-50 flex flex-col gap-3" data-testid="scroll-buttons">
      {showTop && (
        <button
          onClick={scrollToTop}
          className="w-12 h-12 rounded-full bg-[#D4AF37] text-black flex items-center justify-center shadow-lg hover:bg-[#F5D061] transition-colors"
          data-testid="scroll-to-top"
          aria-label="Scroll to top"
        >
          <ChevronUp className="w-6 h-6" />
        </button>
      )}
      {showBottom && (
        <button
          onClick={scrollToBottom}
          className="w-12 h-12 rounded-full bg-[#D4AF37] text-black flex items-center justify-center shadow-lg hover:bg-[#F5D061] transition-colors"
          data-testid="scroll-to-bottom"
          aria-label="Scroll to bottom"
        >
          <ChevronDown className="w-6 h-6" />
        </button>
      )}
    </div>
  );
}
